import React, { useState } from "react";
import Dashboard from "../../layout/Dashboard/Dashboard";
import "./recommendations.scss";
import { Container, Tabs, Tab } from "react-bootstrap";
import ForecastTab from "../../components/Recommendations/ForecastTab";
import CorrelationTab from "../../components/Recommendations/CorrelationTab";

export default function Recommendations() {
  const [activeTab, setActiveTab] = useState("forecast");

  return (
    <div id="mainPage">
      <Dashboard>
        <Container fluid>
          <div className="recommendations-container">
            <h2 className="page-title mb-4">Recommendations & Analytics</h2>

            <Tabs
              id="recommendations-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-4"
            >
              <Tab eventKey="forecast" title="Forecasting">
                <ForecastTab />
              </Tab>
              <Tab eventKey="correlation" title="Correlation Analysis">
                <CorrelationTab />
              </Tab>
            </Tabs>
          </div>
        </Container>
      </Dashboard>
    </div>
  );
}
